import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var NoDisplayIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#clip0_511_39780)",
                            children: _jsx("path", {
                                d: "M1.72.31A1 1 0 10.28 1.69l1.88 2A3 3 0 001 6.01v9a3 3 0 003 3h5.25a1.28 1.28 0 01-.14.55 6.781 6.781 0 01-1.32 1.74 1 1 0 00.71 1.71h7a1 1 0 00.71-1.71 6.783 6.783 0 01-1.32-1.74 1.28 1.28 0 01-.14-.55h1.07l4.46 4.68a1 1 0 001.41 0 1 1 0 000-1.41L1.72.31zm8.87 19.7c.11-.18.21-.37.3-.55a3.2 3.2 0 00.36-1.45h1.5a3.2 3.2 0 00.36 1.45c.09.18.19.37.3.55h-2.82zm-6.59-4a1 1 0 01-1-1v-9a1 1 0 01.55-.88l10.37 10.88H4zM20 3.01H8a1 1 0 000 2h12a1 1 0 011 1v9.08a1 1 0 01-.48.82 1 1 0 00-.4 1.35 1 1 0 00.88.52 1 1 0 00.48-.12A2.93 2.93 0 0023 15.08V6.01a3 3 0 00-3-3z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "clip0_511_39780",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
NoDisplayIcon.isCarinaIcon = true;
export default NoDisplayIcon;
